import { useCallback, useEffect, useState } from 'react'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import { userSignupValidation } from '~/components/atoms/SignupForm/hooks'
import { multiPostHogEventPusher } from '~/utils/analyticsPusher'

export const newsletterSignUpValidation = {
  ...userSignupValidation,
}

export const useReportAdvertForm = (defaultValues: any, formOpen?: boolean) => {
  const [errorMessage, setErrorMessage] = useState('')
  const [success, setSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setSuccess(false)
    setIsLoading(false)
    formik.resetForm()
  }, [formOpen])

  const submitHandler = useCallback(
    async ({
      email,
      firstname,
      lastname,
      phoneNumber,
    }: {
      email: string
      firstname: string
      lastname: string
      phoneNumber: string
    }) => {
      setIsLoading(true)

      try {
        await multiPostHogEventPusher([
          {
            eventType: `Report Advert signup submitted`,
          },
        ])

        setSuccess(true)
        formik.resetForm()
      } catch {
        const errorMessage =
          'Apologies, there was an issue submitting the form. Please try again, or contact us.'
        setErrorMessage(errorMessage)
      } finally {
        setIsLoading(false)
      }
    },
    [setSuccess, setErrorMessage, setIsLoading]
  )

  const formik = useFormik({
    onSubmit: submitHandler,
    validationSchema: Yup.object({
      ...userSignupValidation,
    }),
    validateOnChange: true,
    initialValues: {
      firstname: defaultValues?.firstname || '',
      lastname: defaultValues?.lastname || '',
      email: defaultValues?.emailAddress || '',
      phoneNumber: defaultValues?.phoneNumber || '',
    },
  })

  useEffect(() => {
    const timeout = setTimeout(() => {
      setErrorMessage('')
    }, 30000)

    return () => {
      clearTimeout(timeout)
    }
  }, [errorMessage])

  return {
    formik,
    success,
    errorMessage,
    isLoading,
  }
}
